import classnames from 'classnames'
import styles from './restaurants.module.scss'
import { makeRequest } from '../../services/axios'
import { GetServerSideProps, InferGetServerSidePropsType } from 'next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLocationDot, faClock } from '@fortawesome/free-solid-svg-icons'
import { Restaurant, Shifts, Day } from '../../types'
import { OpeningHours } from '../../services/openingHours'
import { useRouter } from 'next/router'
import Image from 'next/image'
import { RestaurantSearch } from '../../components/RestaurantSearch/RestaurantSearch'
import { useTranslation } from 'react-i18next'
import CardGroup from 'react-bootstrap/CardGroup'
import { Row, Col } from 'react-bootstrap'
import Link from 'next/link'
import ErrorPage from '../500'
import { addLocaleToPath, getLocaleFromRouter } from '../../lib/addLocaleToPath'

const Restaurants = ({ restaurants }: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  const router = useRouter()
  const { query } = router
  const locale = getLocaleFromRouter(router.asPath)
  const { t } = useTranslation(['common'])

  if (query && query.search) {
    restaurants = restaurants.filter(
      (rest: Restaurant) =>
        rest?.restaurantName?.toLowerCase()?.includes((query.search as string).toLowerCase()) ||
        rest?.restaurantAddress?.restaurantCity?.toLowerCase()?.includes((query.search as string).toLowerCase()) ||
        rest?.restaurantTagOne?.toLowerCase()?.includes((query.search as string).toLowerCase())
    )
  }
  if (restaurants) {
    return (
      <div className="">
        <div className={classnames(styles.contentContainer, 'pt-4 w-100 d-flex')}>
          <div className={classnames('w-100 text-center m-auto', styles.searchContainer)}>
            <h2 className="text-white">ALLE RESTAURANTS</h2>
            {RestaurantSearch('restaurants', 'search')}
          </div>
        </div>
        <div className="mx-auto">
          <Row xs={1} md={1} lg={2} xl={3} className={classnames('mx-auto', styles.restaurantContainer)}>
            {restaurants.map((rest: Restaurant, index: number) => {
              const {
                nameUid,
                restaurantName,
                restaurantTagOne,
                restaurantAddress,
                shifts,
                restaurantLogo,
                restaurantPhotos,
                restaurantScheduledClosings,
                showRestaurantInList,
                eventName,
              } = rest || {}
              if (rest) {
                const open = OpeningHours(shifts, restaurantScheduledClosings)
                if (!eventName && showRestaurantInList !== false) {
                  return (
                    <Col key={index}>
                      <Link href={addLocaleToPath(`/restaurant/${rest.nameUid}/profile`, locale)}>
                        <button
                          key={rest.id}
                          className={classnames(
                            styles.restaurantCardContainer,
                            'card btn overflow-hidden my-3 mx-auto p-0 border-0 '
                          )}
                        >
                          <div className={styles.imgZoom}>
                            {restaurantPhotos && restaurantPhotos[0]?.url && (
                              <Image
                                src={`${restaurantPhotos[0]?.url}`}
                                alt="Restaurant Image"
                                fill
                                style={{ objectFit: 'cover' }}
                                placeholder="blur"
                                blurDataURL={`${restaurantPhotos[0]?.url}`}
                              />
                            )}
                          </div>

                          <div
                            className={classnames(styles.restaurantCardLogo, 'mx-auto position-relative')}
                            key={index}
                          >
                            <div className="position-relative h-100 w-100">
                              {restaurantLogo?.url && (
                                <Image
                                  src={`${restaurantLogo?.url}`}
                                  alt="Restaurant Logo"
                                  fill
                                  style={{ objectFit: 'contain' }}
                                  className="p-2"
                                  placeholder="blur"
                                  blurDataURL={`${restaurantLogo.url}`}
                                />
                              )}
                            </div>
                          </div>
                          <div className="card-body w-100">
                            <h5 className="card-title">{restaurantName}</h5>
                            <div className="card-text mb-3">
                              <small>
                                <FontAwesomeIcon icon={faLocationDot} /> {restaurantAddress?.restaurantCity}
                              </small>
                              <br />
                              <small className="text-muted">
                                {restaurantAddress?.restaurantStreet + ' ' + restaurantAddress?.restaurantHouseNumber}
                              </small>
                              <br />
                              {open?.isOpen ? (
                                <div>
                                  <small>
                                    <FontAwesomeIcon icon={faClock} color={'#28a745'} /> {t('common:today')}
                                  </small>
                                  <br />
                                  <small className="text-muted">
                                    {t('common:openFrom')} {open?.isOpenStart?.slice(0, 5)} {t('common:to')}
                                    {open?.isOpenEnd?.slice(0, 5)} {t('common:oclock')}
                                  </small>
                                </div>
                              ) : null}
                              {open?.opensToday && !open?.isOpen ? (
                                <div>
                                  <small>
                                    <FontAwesomeIcon icon={faClock} color={'#ffc107'} /> {t('common:today')}
                                  </small>
                                  <br />
                                  <small className="text-muted">
                                    {t('common:opensAt')} {open?.opensTodayStart[0]?.slice(0, 5)} {t('common:oclock')}
                                  </small>
                                </div>
                              ) : null}
                              {!open?.opensToday && !open?.isOpen ? (
                                <div>
                                  <small>
                                    <FontAwesomeIcon icon={faClock} color={'#dc3545'} /> {t('common:closedToday')}
                                  </small>
                                </div>
                              ) : null}
                            </div>
                            <div className={classnames(styles.restaurantTags, 'text-uppercase')}>
                              <small>{restaurantTagOne}</small>
                            </div>
                          </div>
                        </button>
                      </Link>
                    </Col>
                  )
                }
              }
            })}
          </Row>
        </div>
      </div>
    )
  } else {
    return <ErrorPage />
  }
}

export const getServerSideProps: GetServerSideProps = async ({ req, res }) => {
  res.setHeader('Cache-Control', 'public, s-maxage=86400')
  let restaurants = null
  await makeRequest('get', '/restaurants')
    .then((res) => {
      if (Array.isArray(res)) {
        restaurants = res
      }
    })
    .catch((e) => {
      console.error('Error when fetching /restaurants ' + e)
    })
  return {
    props: {
      restaurants,
    },
  }
}

export default Restaurants
